import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'luxon' })
export class LuxonPipe implements PipeTransform {
  transform(value: any | DateTime, ...args: any[]): any {
    let [format, fromFormat] = args;
    if (!format) {
      format = 'dd/MM/yyyy';
    }
    if (!fromFormat) {
      fromFormat = 'y-LL-dd hh:mm:ss';
    }
    let datetime = null;
    if (value instanceof DateTime) {
      datetime = value;
    } else if (value) {
      value = value?.date ? value.date : value;
      datetime = DateTime.fromFormat(value.substring(0, 19), fromFormat);
    }
    return datetime ? datetime.toFormat(format) : null;
  }
}

@Pipe({ name: 'luxonU', pure: false })
export class LuxonPipeU extends LuxonPipe implements PipeTransform {}
